import classNames from "classnames";
import { memo, type FC } from "react";
import { NoteFlagIcon } from "@/shared/icons";
import styles from "./styles.module.scss";

type Props = {
  important: boolean;
};

export const ImportantIcon: FC<Props> = memo(({ important }) => {
  return (
    <div className={styles.wrapper}>
      <NoteFlagIcon
        className={classNames(styles.root, {
          [styles.important]: important,
        })}
      />
    </div>
  );
});
